import { render, staticRenderFns } from "./LeaveSite.vue?vue&type=template&id=0a15affe&"
import script from "./LeaveSite.vue?vue&type=script&lang=js&"
export * from "./LeaveSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports